'use client'

import Link from 'next/link'
import React from 'react'

import {
  MapHoverCardShell,
  mapHoverCardPrimaryLinkClassName,
  mapHoverCardSecondaryLinkClassName,
} from '@/components/Location/MapHoverCardShell'
import { useLocale } from '@/lib/i18n/useLocale'
import { useMessages } from '@/lib/i18n/useMessages'
import { getLocationHoverDescription } from '@/lib/locations/getLocationPageCopy'
import type { MapLocationCardData } from '@/lib/locations/mapLocationData'
import { cn } from '@/utilities/ui'

type LocationMapHoverCardProps = {
  card: MapLocationCardData
  className?: string
  closeLabel?: string
  id?: string
  onClose?: () => void
  propertyDetailsLabel?: string
  rentNowLabel?: string
}

export function LocationMapHoverCard({
  card,
  className,
  closeLabel,
  id,
  onClose,
  propertyDetailsLabel,
  rentNowLabel,
}: LocationMapHoverCardProps) {
  const locale = useLocale()
  const messages = useMessages()
  const description = getLocationHoverDescription(card.slug, locale, card.description)
  const resolvedPropertyDetailsLabel =
    propertyDetailsLabel ?? messages.location.mapHoverCard.propertyDetails
  const resolvedRentNowLabel = rentNowLabel ?? messages.location.mapHoverCard.rentNow

  return (
    <MapHoverCardShell
      actions={
        <div className="flex gap-2">
          <Link
            className={cn(
              mapHoverCardPrimaryLinkClassName,
              'min-w-0 flex-1 px-3 text-center leading-tight max-md:px-2',
            )}
            href={card.propertyDetailsHref}
          >
            {resolvedPropertyDetailsLabel}
          </Link>
          <Link className={mapHoverCardSecondaryLinkClassName} href={card.rentNowHref}>
            {resolvedRentNowLabel}
          </Link>
        </div>
      }
      className={className}
      closeLabel={closeLabel}
      description={description}
      id={id}
      name={card.name}
      onClose={onClose}
      previewImage={card.previewImage}
      previewImageAlt={card.previewImageAlt}
    />
  )
}
